import React from "react";
import { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
// import { casinoTabs } from "../../lib/data";
import { slotsData, casinoGames } from "../../lib/data/slots.data";
// import { GamesData } from "./GamesData";
import { casinoTabs } from "../../lib/data";
const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);
  const totalGames = {
    ...casinoTabs.AllGames.slide1,
    ...casinoTabs.AllGames.slide2,
    ...casinoTabs.AllGames.slide3,
    ...casinoTabs.AllGames.slide4,
    ...casinoTabs.AllGames.slide5,
    ...casinoTabs.AllGames.slide6,
    ...casinoTabs.AllGames.slide7,
    ...casinoTabs.AllGames.slide8,
    ...casinoTabs.AllGames.slide9,
    ...slotsData.AllGames.slide1,
    ...slotsData.AllGames.slide2,
    ...slotsData.AllGames.slide3,
    ...slotsData.AllGames.slide4,
    ...slotsData.AllGames.slide5,
    ...slotsData.AllGames.slide6,
    ...slotsData.AllGames.slide7,
    ...slotsData.AllGames.slide8,
    ...slotsData.AllGames.slide9,
    ...slotsData.AllGames.slide10,
  };

  const handleSearch = (e) => {
    if (e) {
      setSearchText(true);

      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1;
      });
      setFilteredData(filteredValue);
    } else {
      setSearchText(false);
    }
  };

  return (
    <div>
      <div className="searchGames" onClick={handleShow}>
        <p>Search Games</p>
        <BiSearch />
      </div>

      <div>
        <Modal show={show} onHide={handleClose} className="searchGames1">
          <Modal.Header closeButton>
            <Modal.Title>Search For Games</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <InputGroup className="mb-3 search-icon">
              <Form.Control
                placeholder="Search"
                aria-label="Text input with dropdown button"
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                // style={{ color: "#000" }}
                autoFocus
              />
            </InputGroup>
            <div className="GamesShow">
              {searchText &&
                filteredData &&
                filteredData.map((item) => (
                  <div className="displayGames">
                    <a href={item.redirectUrl}>
                      {item.imgUrl ? <img src={item.imgUrl} /> : item.img}
                    </a>
                  </div>
                ))}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default GamesSearchModal;
